import { render, staticRenderFns } from "./ContentRichTextModule.vue?vue&type=template&id=1b054d9b&scoped=true"
import script from "./ContentRichTextModule.vue?vue&type=script&lang=js"
export * from "./ContentRichTextModule.vue?vue&type=script&lang=js"
import style0 from "./ContentRichTextModule.vue?vue&type=style&index=0&id=1b054d9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b054d9b",
  null
  
)

export default component.exports